import type { FunctionComponent, PropsWithChildren } from 'react';
import * as styles from './Button.module.css';

export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  PRIMARY_INVERSE: 'primaryInverse',
  TERTIARY: 'tertiary',
  TERTIARY_INVERSE: 'tertiaryInverse',
  CANCEL: 'cancel',
};

type ButtonProps = {
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  style?: Record<string, string>;
  buttonType?: string;
  dataTestId?: string;
};

const Button: FunctionComponent<PropsWithChildren<ButtonProps>> = (props) => {
  const {
    type = 'button',
    disabled,
    onClick,
    className,
    style,
    children,
    buttonType = BUTTON_TYPES.TERTIARY,
    dataTestId = null,
  } = props;

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${styles.button} ${styles[buttonType]} ${className || ''}`}
      style={style}
      data-testid={dataTestId}
    >
      {children}
    </button>
  );
};

export default Button;
